module.exports = __webpack_public_path__ + "static/media/pic16.0fd9ffb3.jpg";